import React from 'react';

import { useResponsiveCss } from 'craft/hooks';
import { CommonNodeProperties, CssSelectorId } from 'craft/types';
import { createToggle } from 'craft/utils';

import { ElementAlignment } from './ElementAlignment';

export interface FlexChildAlignmentProps {
  nodeIds: string[];
  parentCss: any;
  cssSelectorId?: CssSelectorId;
}

export const FlexChildAlignmentSettings = ({
  nodeIds,
  parentCss,
  cssSelectorId,
}: FlexChildAlignmentProps) => {
  const { responsiveCss, setResponsiveCss } = useResponsiveCss(
    nodeIds,
    CommonNodeProperties.Multiple,
    cssSelectorId,
  );

  const { alignSelf } = responsiveCss || {};
  const { flexDirection: parentFlexDirection } = parentCss;

  const toggleValues = createToggle(responsiveCss, setResponsiveCss);

  return (
    <div data-cy="toolbox-flex-child-alignment-settings">
      <ElementAlignment
        toggleValues={toggleValues}
        parentFlexDirection={parentFlexDirection}
        alignSelf={alignSelf}
      />
    </div>
  );
};
